import { Suspense, lazy } from 'react';
import { SummernoteProps } from './summernote.types';
import { StyledSummernoteSkeleton } from './summernote.styles';
const LazySummernoteWrapper = lazy(async () => {
  const {
    SummernoteWrapper
  } = await import('./summernote-wrapper');
  return {
    default: SummernoteWrapper
  };
});

/**
 * This component is primarily designed to be used with libraries like React Hook Form, but can also be used on its own.
 * Don't forget to supply the `options` prop with the desired Summernote options otherwise bare defaults will be used.
 *
 * The component is lazy loaded, to prevent `jQuery` and `summernote` from being included in the initial bundle.
 *
 * ### Usage with React Hook Form
 * Generally to use this component with RHF, you just need to use `register` like you would with a normal input.
 * `defaultValues`, `setValue`, `getValues` etc. should all work as expected.
 *
 * ```
 * const { register } = useForm<{ description: string }>({
 *   defaultValues: { description: '<p>testing123</p>' },
 *  });
 *
 * return <Summernote options={SUMMERNOTE_PATH_OPTIONS} {...register('description')}  />;
 * ```
 * ### Usage *without* React Hook Form
 * If you're not using RHF, you can still use this component, but you'll need to use the `ref` to get the current value.
 *
 * ```
 * const ref = useRef<SummernoteRefContents>(null);
 *
 * return (
 *   <>
 *     <Button
 *       onClick={() => {
 *         alert(ref.current?.value);
 *       }}
 *     >
 *       Show Contents
 *     </Button>
 *     <Summernote options={SUMMERNOTE_PATH_OPTIONS} innerRef={ref} initialContents="<p>testing123</p>" />;
 *   </>
 * );
 * ```
 */
const SummernoteLoader = (props: SummernoteProps) => <Suspense fallback={<StyledSummernoteSkeleton />} data-sentry-element="Suspense" data-sentry-component="SummernoteLoader" data-sentry-source-file="summernote-loader.tsx">
    <LazySummernoteWrapper {...props} data-sentry-element="LazySummernoteWrapper" data-sentry-source-file="summernote-loader.tsx" />
  </Suspense>;
export { SummernoteLoader as Summernote };